import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/campaignQuoteTemplate/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/campaignQuoteTemplate/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/campaignQuoteTemplate/FETCH_FAILURE'
const UPDATE_REQUEST = 'realhub/campaignQuoteTemplate/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/campaignQuoteTemplate/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/campaignQuoteTemplate/UPDATE_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loadedIds: [],
  loading: false,
  errors: [],
  updating: false,
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
    errors: [],
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadCampaignQuoteTemplates(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    const promise = api('/admin/campaign_quote_templates.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.CAMPAIGN_QUOTE_TEMPLATE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(normalizedJson))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function loadCampaignQuoteTemplate(campaignQuoteTemplate, options){
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.campaignQuoteTemplates.loadedIds ? state.campaignQuoteTemplates.loadedIds.slice() : []
    if (!loadedIds.includes(campaignQuoteTemplate.id)){
      loadedIds.push(campaignQuoteTemplate.id)
    }

    dispatch(fetchRequest({ loadedIds }))

    const promise = api(`/admin/campaign_quote_templates/${campaignQuoteTemplate.id}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.CAMPAIGN_QUOTE_TEMPLATE)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function updateCampaignQuoteTemplate(campaignQuoteTemplate, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      campaign_quote_template: campaignQuoteTemplate,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/campaign_quote_templates/${campaignQuoteTemplate.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.CAMPAIGN_QUOTE_TEMPLATE)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

export function duplicateCampaignQuoteTemplate(campaignQuoteTemplate, options, callback){
  const { id, agency_ids } = campaignQuoteTemplate

  const config = {
    method: 'POST',
    body: JSON.stringify({
      agency_ids,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest)

    const promise = api(`/admin/campaign_quote_templates/${id}/duplicate_template.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.CAMPAIGN_QUOTE_TEMPLATE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: action.result,
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
